// ©2024 Austin App House. All rights reserved.
import React from "react";
import {MDBBtn, MDBCol, MDBRow} from "mdbreact";
import formatAMPM from "../../../../utils/formatAMPM";
import getTotalHour from '../../../../utils/getTotalHourByDates';
import {getDateWithOffset} from "../../../../utils/getDateWithOffset";

const CheckInCheckOutElement = ({
                                    isControlElementAvailable,
                                    checkInCheckOutInfo,
                                    editCheckData,
                                    deleteCheckData,
                                    userType
                                }) => (
    <div className="">
        <div className="field_block">
            <div className="font11 d-flex divworkdetail">
                <div className="field_name">
                    <span style={{fontWeight: "bold"}}>Check In</span>
                    <span className="dashdiv">-</span>
                    <span>
                    {
                        (new Date(
                            checkInCheckOutInfo.check_in_date
                        ).toLocaleDateString('en-US', {timeZone: 'UTC'}) === "Invalid Date")
                            ?
                            ""
                            :
                            new Date(
                                checkInCheckOutInfo.check_in_date
                            ).toLocaleDateString('en-US', {timeZone: 'UTC'})
                            + "-" + formatAMPM(getDateWithOffset(checkInCheckOutInfo.check_in_date))
                    }
                    </span>
                </div>
                <div className="field_name">
                    <span style={{fontWeight: "bold"}}>Check Out</span>
                    <span className="dashdiv">-</span>
                    <span>
                    {
                        !checkInCheckOutInfo.check_out_date || (new Date(
                            checkInCheckOutInfo.check_out_date
                        ).toLocaleDateString('en-US', {timeZone: 'UTC'}) === "Invalid Date")
                            ?
                            ""
                            :
                            new Date(
                                checkInCheckOutInfo.check_out_date
                            ).toLocaleDateString('en-US', {timeZone: 'UTC'})
                            + "-" + formatAMPM(getDateWithOffset(checkInCheckOutInfo.check_out_date))
                    }
                    </span>
                </div>
                <div className="field_name">
                    <span style={{fontWeight: "bold"}}>Total Hours</span>
                    <span
                        className="dashdiv">-</span><span>{getTotalHour(new Date(checkInCheckOutInfo.check_in_date), new Date(checkInCheckOutInfo.check_out_date))}</span>
                </div>
            </div>
        </div>
        <div className="field_name">
            <span style={{fontWeight: "bold"}}>Work Description</span>
            <span className="dashdiv">-</span>
            <span>
               {(checkInCheckOutInfo.work_description !== "false") ? checkInCheckOutInfo.work_description : ""}
            </span>
        </div>
        {
            userType !== 'contractor'
            && (
                checkInCheckOutInfo.checkInLocationInfo?.coords
                || checkInCheckOutInfo.checkOutLocationInfo?.coords
            )
                ? <div className="field_block">
                    {
                        checkInCheckOutInfo.checkInLocationInfo?.coords
                            ? <div className="field_name">
                                <label>Check In was added at a distance
                                    of {checkInCheckOutInfo.checkInLocationInfo?.distance?.toFixed(2) + " Miles"}
                                </label>
                              </div>
                            : <></>
                    }
                    {
                        checkInCheckOutInfo.checkOutLocationInfo?.coords
                            ? <div className="field_name">
                                <label>Check Out was added at a distance
                                    of {checkInCheckOutInfo.checkOutLocationInfo?.distance?.toFixed(2) + " Miles"}</label>
                              </div>
                            : <></>
                    }
                </div>
                : <></>
        }
        {
            isControlElementAvailable
            && <div className="dashboard-modal-footer">
                <div>
                    <button
                        color="info"
                        className="dashboard-btn dashboard-btn--secondary"
                        onClick={event => editCheckData(event, checkInCheckOutInfo)}
                    >
                        Edit
                    </button>
                </div>
                <div>
                    <button
                        color="deep-orange"
                        className="standard_btn lightest_btn"
                        onClick={event => deleteCheckData(event, checkInCheckOutInfo._id)}
                    >
                        Delete
                    </button>
                </div>
            </div>
        }
    </div>
)

export default CheckInCheckOutElement